// src/features/pageSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setSelectedLevelBoxWithStatus } from './vipSlice';
import { setSelectedGiftBox } from './receivedBoxesSlice';
import { AppDispatch, RootState } from '../app/store';

export const handlePageSelection = (selectedPage: string) => (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(selectPage(selectedPage));

  if (selectedPage !== "vips") {
    dispatch(setSelectedLevelBoxWithStatus(null));
  }

  if (selectedPage !== "gifts") {
    dispatch(setSelectedGiftBox(null));
  }
};


interface PageState {
  selectedPage: string;
}

const initialState: PageState = {
  selectedPage: 'boxes', // Default selected page
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    selectPage: (state, action: PayloadAction<string>) => {
      state.selectedPage = action.payload;
    },
  },
});

export const { selectPage } = pageSlice.actions;
export default pageSlice.reducer;
